module.exports = require('./gherkin-languages.json');
